import { create } from 'zustand';
import axiosInstance from '../api/axiosInstance';
import Base64e from '../components/encodedecode/encode';
import useAuthStore from './useAuthStore';

interface Genre {
  id: number;
  name: string;
  title: string; // Category title
}
interface Request {
  notificationsCount: number;
  matchedCount: number;
  newRequestCount: number; // Category title
  newRequests:any[];
}
interface UserState {
  user: any | null;
  loading: boolean;
  error: string | null;
  getUserDetails: (userId: number) => Promise<any>;
  deleteUser: (userId: number) => Promise<any>;
  genres: Genre[];
  fetchGenres: () => Promise<void>;
  newRequest:Request;
  getNewRequests:(userId:number)=>Promise<any>;
  markRequestsAsSeen:(userId:number)=>Promise<any>;
  updateOnlineStatus:(userId:number)=>Promise<any>;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  loading: false,
  error: null,
  genres: [],
  newRequest:{matchedCount:0,newRequestCount:0,newRequests:[],notificationsCount:0,},
  fetchGenres: async () => {
    try {
      const response = await axiosInstance.get('/getGenres');
      const genres: Genre[] = response.data.rows;

      set({ genres });
    } catch (error) {
      console.error('Error fetching genres:', error);
    }
  },
  updateOnlineStatus:async (userId) => {
    try {
      await axiosInstance.post('/updateOnlineStatus',{id:userId});
      
    } catch (error) {
      console.error('Error fetching updateOnlineStatus:', error);
    }
  },
  getUserDetails: async (userId) => {
    set({ loading: true, error: null });

    try {
      const authStore = useAuthStore.getState();
      const lat = authStore.user?.lat;
      const lang = authStore.user?.lang;
      const response = await axiosInstance.post('getSingleUser', {
        id: Base64e.encode(userId+''),
        lat: lat || '0', // Replace with actual lat
        lang: lang || '0', // Replace with actual lng
        Rid: '',
        uId: '',
      });

      if (response.status === 200 && response.data) {
        const userData = response.data.rows.rows[0];
        set({ user: userData, loading: false });
        return userData; // Return the fetched user data
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      set({ error: 'Failed to fetch user data', loading: false });
    }
  },

  getNewRequests: async (userId) => {
    set({ loading: false, error: null });
   
    try {
     const response = await axiosInstance.post('getnewRequests', {
        user: userId,
       });

      if (response.status === 200 && response.data) {
        const newRequest = response.data;
        console.log(newRequest);
        
        set({ newRequest: newRequest, loading: false });
        return newRequest; // Return the fetched user data
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      set({ error: 'Failed to fetch user data', loading: false });
    }
  },
 deleteUser: async (userId: any) => {
  set({ loading: true, error: null });

  try {
    const response = await axiosInstance.post("/deleteuser", { id: userId });

    if (response.status === 200) {
      console.log("User deleted:", response.data);

         // Clear user store
      set({
        user: null,
        newRequest: {
          matchedCount: 0,
          newRequestCount: 0,
          newRequests: [],
          notificationsCount: 0,
        },
        loading: false,
      });

      return response.data;
    }
  } catch (error) {
    console.error("Error deleting user:", error);
    set({ error: "Failed to delete user", loading: false });
  }
},
  markRequestsAsSeen: async (userId) => {
    set({ loading: true, error: null });
  
    try {
      const response = await axiosInstance.post("markRequestsAsSeen", {
        user: userId,
      });
  
      if (response.status === 200) {
        console.log("Requests marked as seen:", response.data);
  
        // Update the state by reducing the count of unseen requests
        set((state) => ({
          newRequest: {
            ...state.newRequest,
            newRequestCount: 0, // Reset new request count
            matchedCount: state.newRequest.matchedCount, // Keep matched count unchanged
          },
          loading: false,
        }));
  
        return response.data;
      }
    } catch (error) {
      console.error("Error marking requests as seen:", error);
      set({ error: "Failed to mark requests as seen", loading: false });
    }
  },
}));
